import styled from 'styled-components';

export const StyledHeadline = /*#__PURE__*/styled.h1.withConfig({ displayName: "styles__StyledHeadline", componentId: "sc-axn30k-0" })(["color:", ";padding-bottom:", ";", ";"],
(props) => props.titleColor ?? props.theme.colors.Foreground,
({ theme }) => theme.spacers.XXL,
({ theme }) => theme.typography.Headline);


export const StyledSubHeadline = /*#__PURE__*/styled.h2.withConfig({ displayName: "styles__StyledSubHeadline", componentId: "sc-axn30k-1" })(["color:", ";padding-bottom:", ";", ""],
(props) => props.titleColor ?? props.theme.colors.Foreground,
({ theme }) => theme.spacers.L,
({ theme }) => theme.typography.Subheadline);


export const StyledSmallHeadline = /*#__PURE__*/styled.h3.withConfig({ displayName: "styles__StyledSmallHeadline", componentId: "sc-axn30k-2" })(["color:", ";padding-bottom:", ";", ""],
(props) => props.titleColor ?? props.theme.colors.Foreground,
({ theme }) => theme.spacers.M,
({ theme }) => theme.typography.SmallHeadline);


export const StyledSmallCapsHeadline = /*#__PURE__*/styled.h4.withConfig({ displayName: "styles__StyledSmallCapsHeadline", componentId: "sc-axn30k-3" })(["color:", ";padding-bottom:12px;", ""],
(props) => props.titleColor ?? props.theme.colors.Foreground,

({ theme }) => theme.typography.SmallCapsHeadline);


export const StyledParagraph = /*#__PURE__*/styled.p.withConfig({ displayName: "styles__StyledParagraph", componentId: "sc-axn30k-4" })(["color:", ";", " > a{color:", ";text-decoration:underline;}"],
(props) => props.paragraphColor ?? props.theme.colors['Level 5'],

({ theme }) => theme.typography.Paragraph,


(props) => props.paragraphColor ?? props.theme.colors['Level 5']);